import logger from 'shared/services/logger'
import store from 'shared/store'
import { CART_SPA_MOUNTED } from 'shared/store/ducks/cart/types.consts'
import { SPA_CART } from 'views/consts'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

let loaded = false

const hydrate = async () => {
  loaded = true
  const container = document.getElementById(SPA_CART)
  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()

  try {
    // TODO instead of refreshing the TOKEN we will unpack
    // the JWT and check for the expiration date

    const i18n = await loadCatalogs(locale)
    const hydrateCart = await import(
      /* webpackChunkName: "CartWithHydration" */
      './CartWithHydration'
    )
    hydrateCart.default({
      container,
      i18n,
    })
  } catch (e) {
    logger.error(`mountSPA hydration: ${e.message}`)
  }
}

export default async () => {
  if (!loaded) {
    await hydrate()
    store.dispatch({ type: CART_SPA_MOUNTED })
  }
}
